import { render, staticRenderFns } from "./GlobalStats.vue?vue&type=template&id=12addfd1&scoped=true&"
import script from "./GlobalStats.vue?vue&type=script&lang=js&"
export * from "./GlobalStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12addfd1",
  null
  
)

export default component.exports